import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Canvas from "./Canvas";
import {IZO_TRANSFORM_A, IZO_TRANSFORM_B, IZO_TRANSFORM_C, IZO_TRANSFORM_D} from "../../utils/Constant";

class Site extends Canvas {

  componentDidMount() {

    this.ctx = this.refs.canvas.getContext('2d');
    this.ctx.imageSmoothingQuality = 'high';
    this.props.setCtx(this.ctx);

    this.draw();

  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.square !== this.props.square || prevProps.field !== this.props.field) {
      this.draw();
    }

    if (prevProps.coordinates !== this.props.coordinates) {
      this.draw();
    }

    if (prevProps.position !== this.props.position) {
      this.draw();
    }
    if (prevProps.viewTop !== this.props.viewTop) {
      this.draw();
    }
    if (prevProps.base !== this.props.base) {
      this.draw();
    }

  }


  draw = (x = this.props.position.x, y = this.props.position.y) => {

    this.clear(true);
    this.ctx.save();

    const {lineWidth, square, grassMod} = this.state;
    const scale = this.props.sizes.scale;

    let lineWidthWihScale = lineWidth * scale < 0 ? 1 : lineWidth * scale;
    const grassSquareSize = square * grassMod;
    const grassSquareSizeX2 = grassSquareSize * 2;
    const fieldSquareWidth = this.props.field.width * square;
    const fieldSquareHeight = this.props.field.height * square;

    if (this.props.viewTop) {
      //Вычисление сдвига для самой площадки не требуется, поскольку сама площадка - это точка отсчета:
      //let shiftBackXY = CanvasHelper.calculateBackTransform(0, 0, a, b, c, d, scale); //параметры x и y = 0 - т.е. нет сдвига самой базы
      //this.backTransformWithFlipAndRotate(x + shiftBackXY.x, y + shiftBackXY.y, scale); //где shiftBackXY фактически {0,0}, т.е. x+0, y+0
      //Вызов метода трансформации площадки сокращается до:
      this.backTransformWithFlipAndRotate(x, y, scale);

    } else {
      this.ctx.transform(IZO_TRANSFORM_A, IZO_TRANSFORM_B, IZO_TRANSFORM_C, IZO_TRANSFORM_D, x, y);
    }

    this.ctx.scale(scale, scale);
    this.tile(this.props.square, grassSquareSize, grassSquareSize, fieldSquareWidth, fieldSquareHeight);

    this.cutOnBorders(lineWidthWihScale);
    this.drawBorders(lineWidthWihScale);
    this.ctx.globalCompositeOperation = "destination-over";

    if (!this.props.viewTop) {
      this.tile(this.props.grass, 0, 0, fieldSquareWidth + grassSquareSizeX2, fieldSquareHeight + grassSquareSizeX2);
      this.drawDirt();
    }


  };

  drawBorders = (lineWidth) => {
    let coordinates = this.getRealCoordinates();

    if (coordinates && coordinates.length > 0) {

      this.ctx.beginPath();

      let strokeStyle = '#E6E6E6';

      if (this.props.viewTop) {
        strokeStyle = '#000000';
        lineWidth = 2
      } else {

        this.ctx.lineJoin = 'bevel';
        this.ctx.strokeStyle = "#B9B9B9";

        for (let i = 0; i < coordinates.length; i++) {
          if (coordinates[i]) {
            this.ctx.lineTo(coordinates[i].x + lineWidth / 1.5, coordinates[i].y - lineWidth / 1.5);
          }
        }
      }

      this.ctx.lineWidth = lineWidth;

      this.ctx.lineTo(coordinates[0].x + lineWidth / 1.5, coordinates[0].y - lineWidth / 1.5 - lineWidth / 2);
      this.ctx.stroke();
      this.ctx.closePath();

      this.ctx.beginPath();
      this.ctx.strokeStyle = strokeStyle;

      for (let i = 0; i < coordinates.length; i++) {

        if (coordinates[i]) {
          this.ctx.lineTo(coordinates[i].x, coordinates[i].y);
        }

      }

      this.ctx.lineTo(coordinates[0].x, coordinates[0].y - lineWidth / 2);
      this.ctx.stroke();
      this.ctx.closePath();
    }
  };

  cutOnBorders = () => {
    const coordinates = this.getRealCoordinates();

    if (coordinates) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = "black";
      this.ctx.globalCompositeOperation = "destination-in";
      coordinates.forEach((pt) => {
        if (pt) {
          this.ctx.lineTo(pt.x, pt.y);
        }
      });
      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.globalCompositeOperation = "source-over";
    }

  };

  drawDirt = () => {

    const grassWidth = this.state.square * this.state.grassMod * 2;

    const endPointX = this.props.field.width * this.state.square + grassWidth;
    const endPointY = this.props.field.height * this.state.square + grassWidth;

    this.ctx.save();
    this.ctx.transform(1, 0, -0.7, 0.42, 0, 0);

    for (let x = 0; x < endPointX; x += this.state.square) {
      this.ctx.drawImage(this.props.dirt, x, -this.state.square);
    }

    this.ctx.restore();
    this.ctx.save();

    this.ctx.rotate(90 * Math.PI / 180);
    this.ctx.transform(1, 0, 0.4, 0.66, -endPointY, -endPointX);

    for (let x = endPointY; x < (endPointY * 2); x += this.state.square) {
      this.ctx.drawImage(this.props.dirt, x, -this.state.square);
    }

    this.ctx.restore();
  };

  render() {
    return <canvas
      ref="canvas"
      width={this.props.sizes.width}
      height={this.props.sizes.height}

      onMouseDown={(e) => {

        const {x, y} = this.getOffsetXY(e.clientX, e.clientY);

        if (this.isHit(x, y)) {

          const oldPosition = {
            x: (x - this.props.position.x),
            y: (y - this.props.position.y)
          };

          this.setState({
            selected: this.ctx,
            oldPosition
          });
        }

      }}

      onMouseMove={(e) => {
        if (this.state.selected instanceof CanvasRenderingContext2D) {
          const {x, y} = this.getOffsetXY(e.clientX, e.clientY);
          this.moveTo(x - this.state.oldPosition.x, y - this.state.oldPosition.y);
        }

      }}

      onMouseUp={() => {

        this.setState({
          selected: null,
          oldPosition: {}
        });

        ReactDOM.findDOMNode(this.refs.canvas).style.cursor = 'default';
        this.props.moveTo(this.props.position.x, this.props.position.y);

      }}

    />
  }
}

Site.propTypes = {
  sizes: PropTypes.object.isRequired,
  setCtx: PropTypes.func,
};


export default Site;
